module.exports = __webpack_public_path__ + "media/aboutPage/second-section-image-e7982239.png";